import React from 'react';
import '../styles/about.css'; // Import custom CSS file for additional styling
import myimage from '../images/mahesh.png';

const AboutMe = () => {
  return (
    <section className="about-me bg-black">
    <div className="container text-light ">
    <h1 className="section-title fw-bold text-light">About Me</h1> <hr/>

      {/* About Header */}
      <div className="row align-items-center">
  {/* Left Column with Circular Image */}
  <div className="col-md-6 text-center mb-4">
    <img 
      src={myimage} // Replace with your image path
      alt="Bandaru Mahesh"
      className="img-fluid rounded-circle" 
      style={{ width: '300px', height: '300px' }} // Adjust size as needed
    />
  </div>
  
  {/* Right Column with Description */}
  <div className="col-md-6">
    <p className="fw-bold">
 Founder and CEO of Olewin, where we specialize in developing innovative web and mobile applications as SaaS solutions.
    </p>
    <p>
      As a forward-thinking leader, I leverage my expertise in AI & ML, Quantum Computing, Big Data, and Multi-Cloud Solutions to drive technological innovation. My background in Geophysical Exploration and the Energy Sector informs my holistic approach to Full Stack Development and Blockchain Technology. At Olewintech Solutions, my mission is to empower businesses with advanced technological solutions that tackle modern challenges and ensure they remain competitive in a rapidly evolving market.
    </p>
  </div>
</div>

      
      {/* About Content */}
      <div className="row align-items-center mb-5">
        <div className="col-md-6 mb-4 mb-md-0">
          <h2 className="text-secondary fw-bold">
            I'm <span className="highlight">Bandaru Mahesh</span> <br/> Founder / CEO of a Olewin
          </h2>
          <p>
            I am dedicated to building affordable brand solutions for businesses, ensuring exceptional results for our clients through our committed team. Our motto is to deliver projects on time and within budget, meeting all client specifications.
          </p>
          <p><a className="text-dark btn btn-light rounded-pill w-50 fw-bold" target='_blank' rel='noreferrer' href="https://olewintechsolutions.com">Visit website</a></p>
        </div>
        <div className="about-details">
          <ul>
            <li><strong>Name:</strong> Bandaru Mahesh</li>
            <li><strong>Gmail:</strong> <a href="mailto:bandarumahesh2024@gmail.com">bandarumahesh2024@gmail.com</a></li>
            <li><strong>Email:</strong> <a href="mailto:bandarumahesh@iitkgp.ac.in">bandarumahesh@iitkgp.ac.in</a></li>
            <li><strong>Age:</strong> 29</li>
            <li><strong>Location:</strong> Andhra Pradesh, India</li>
          </ul>
          {/* <a href="/" className="btn-download">Download CV</a> */}
        </div>
      </div>
  
      {/* About Stats */}
      <div className="row text-center">
        <div className="col-6 col-md-3 mb-4">
          <div className="stat-item">
            <h3>7+</h3>
            <p>Years of Programming Experience</p>
          </div>
        </div>
        <div className="col-6 col-md-3 mb-4">
          <div className="stat-item">
            <h3>25+</h3>
            <p>Satisfied Clients</p>
          </div>
        </div>
        <div className="col-6 col-md-3 mb-4">
          <div className="stat-item">
            <h3>25+</h3>
            <p>Completed Projects</p>
          </div>
        </div>
        <div className="col-6 col-md-3 mb-4">
          <div className="stat-item">
            <h3>170k+</h3>
            <p>GitHub Contributions</p>
          </div>
        </div>
      </div>
    </div>
  </section>
  
  );
};

export default AboutMe;
